import { mergeMeasureAttributes } from "@treegram/viewer-core";
import ProjectMeasuresDto from "@/models/interfaces/dtos/measure/get/project-measures-dto.ts";
import ProjectMeasures from "@/pages/takeoff/context/project-measure/models/project-measures.ts";
import BuildingMeasures from "@/pages/takeoff/context/project-measure/models/building-measures.ts";
import StoreyMeasures from "@/pages/takeoff/context/project-measure/models/storey-measures.ts";
import Measure from "@/pages/takeoff/context/project-measure/models/measure.ts";
import GeometryRepresentation from "@/pages/takeoff/context/project-measure/models/geometry-representation.ts";

const createProjectMeasuresFromDto = (dto: ProjectMeasuresDto): ProjectMeasures => {
    const tempMeasures = new ProjectMeasures();

    dto.buildings.forEach((buildingDto) => {
        const buildingMeasure = new BuildingMeasures(buildingDto.buildingId, buildingDto.name);

        buildingDto.storeys.forEach((storeyDto) => {
            const storeyMeasure = new StoreyMeasures(
                storeyDto.storeyId,
                storeyDto.name,
                storeyDto.index,
                storeyDto.altimetry,
            );

            storeyDto.measures.forEach((measureDto) => {
                let dataInformations: Record<string, unknown> | undefined;
                if (measureDto.dataInformations) {
                    try {
                        dataInformations = JSON.parse(measureDto.dataInformations);
                    } catch {
                        // Intentionally ignore invalid JSON
                    }
                }

                const measure = new Measure(
                    measureDto.measureType.measureTypeId,
                    measureDto.name,
                    measureDto.measureId,
                    mergeMeasureAttributes(
                        measureDto.measureType.measureRepresentationId,
                        JSON.parse(measureDto.measureType.dataInformations || "{}"),
                        dataInformations,
                    ),
                );

                measureDto.geometryRepresentations.forEach((representationDto) => {
                    const geometry = new GeometryRepresentation(
                        representationDto.geometryId,
                        representationDto.operation,
                        representationDto.geometryRepresentationId,
                    );
                    measure.geometryRepresentations.push(geometry);
                });

                storeyMeasure.measures.push(measure);
            });

            buildingMeasure.storeys.push(storeyMeasure);
        });

        tempMeasures.buildings.push(buildingMeasure);
    });

    tempMeasures.buildings.forEach((building) => {
        building.storeys.sort((a, b) => b.altimetry - a.altimetry);
    });

    return tempMeasures;
};

export default createProjectMeasuresFromDto;
